module.exports = "data:image/png;base64,bW9kdWxlLmV4cG9ydHMgPSBfX3dlYnBhY2tfcHVibGljX3BhdGhfXyArICJzdGF0aWMvaWNvbnMvbXN0aWxlLTMxMHgxNTAucG5nIjs="


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/mstile-310x150.png
// module id = luhc
// module chunks = 0